import type { App } from 'vue'
import { Icon } from './Icon'
import { Permission } from './Permission'
import { BaseButton } from './Button'
import { WebMediaPreview } from './WebMediaPreview'

export const setupGlobCom = (app: App<Element>): void => {
  app.component('Icon', Icon)
  app.component('Permission', Permission)
  app.component('BaseButton', BaseButton)
  app.component('WebMediaPreview', WebMediaPreview)
}

export { Icon, Permission, BaseButton, WebMediaPreview }
